









import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'


@Component({
  components: {
    YourAccountHelperComponents1MainPage: () => import('../../../html-components-type-2-application-specific/application-specific-type-2-pages/pages-type-1-your-account/service-for-your-account-helper-components/your-account-helper-components-1-main-page.vue')
  }
})
class FolderItemView3AccountView extends Vue {
  @Prop({ default: '' }) accountId?: string
}

export default FolderItemView3AccountView

